var map = {
	"./annotation/annotation_celltypist.json": [
		"./src/schema/react-json-schema/Tools/annotation/annotation_celltypist.json",
		"src_schema_react-json-schema_Tools_annotation_annotation_celltypist_json"
	],
	"./annotation/annotation_scanvi.json": [
		"./src/schema/react-json-schema/Tools/annotation/annotation_scanvi.json",
		"src_schema_react-json-schema_Tools_annotation_annotation_scanvi_json"
	],
	"./annotation/annotation_singler.json": [
		"./src/schema/react-json-schema/Tools/annotation/annotation_singler.json",
		"src_schema_react-json-schema_Tools_annotation_annotation_singler_json"
	],
	"./evaluation/evaluation_cidr.json": [
		"./src/schema/react-json-schema/Tools/evaluation/evaluation_cidr.json",
		"src_schema_react-json-schema_Tools_evaluation_evaluation_cidr_json"
	],
	"./evaluation/evaluation_seurat.json": [
		"./src/schema/react-json-schema/Tools/evaluation/evaluation_seurat.json",
		"src_schema_react-json-schema_Tools_evaluation_evaluation_seurat_json"
	],
	"./formatting/formatting_convert.json": [
		"./src/schema/react-json-schema/Tools/formatting/formatting_convert.json",
		"src_schema_react-json-schema_Tools_formatting_formatting_convert_json"
	],
	"./imputation/imputation_magic.json": [
		"./src/schema/react-json-schema/Tools/imputation/imputation_magic.json",
		"src_schema_react-json-schema_Tools_imputation_imputation_magic_json"
	],
	"./imputation/imputation_saver.json": [
		"./src/schema/react-json-schema/Tools/imputation/imputation_saver.json",
		"src_schema_react-json-schema_Tools_imputation_imputation_saver_json"
	],
	"./imputation/imputation_scgnn.json": [
		"./src/schema/react-json-schema/Tools/imputation/imputation_scgnn.json",
		"src_schema_react-json-schema_Tools_imputation_imputation_scgnn_json"
	],
	"./integration/integration_harmony.json": [
		"./src/schema/react-json-schema/Tools/integration/integration_harmony.json",
		"src_schema_react-json-schema_Tools_integration_integration_harmony_json"
	],
	"./integration/integration_liger.json": [
		"./src/schema/react-json-schema/Tools/integration/integration_liger.json",
		"src_schema_react-json-schema_Tools_integration_integration_liger_json"
	],
	"./integration/integration_scvi.json": [
		"./src/schema/react-json-schema/Tools/integration/integration_scvi.json",
		"src_schema_react-json-schema_Tools_integration_integration_scvi_json"
	],
	"./integration/integration_seurat.json": [
		"./src/schema/react-json-schema/Tools/integration/integration_seurat.json",
		"src_schema_react-json-schema_Tools_integration_integration_seurat_json"
	],
	"./normalization/normalization_deseq2.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_deseq2.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_deseq2_json"
	],
	"./normalization/normalization_fpkm.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_fpkm.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_fpkm_json"
	],
	"./normalization/normalization_logcp10k.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_logcp10k.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_logcp10k_json"
	],
	"./normalization/normalization_logcpm.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_logcpm.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_logcpm_json"
	],
	"./normalization/normalization_pearson_residuals.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_pearson_residuals.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_pearson_residuals_json"
	],
	"./normalization/normalization_rle.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_rle.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_rle_json"
	],
	"./normalization/normalization_scran.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_scran.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_scran_json"
	],
	"./normalization/normalization_sctransform.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_sctransform.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_sctransform_json"
	],
	"./normalization/normalization_tmm.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_tmm.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_tmm_json"
	],
	"./normalization/normalization_tpm.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_tpm.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_tpm_json"
	],
	"./normalization/normalization_upperquartile.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_upperquartile.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_upperquartile_json"
	],
	"./normalization/normalization_uq.json": [
		"./src/schema/react-json-schema/Tools/normalization/normalization_uq.json",
		"src_schema_react-json-schema_Tools_normalization_normalization_uq_json"
	],
	"./quality_control/quality_control_bioconductor.json": [
		"./src/schema/react-json-schema/Tools/quality_control/quality_control_bioconductor.json",
		"src_schema_react-json-schema_Tools_quality_control_quality_control_bioconductor_json"
	],
	"./quality_control/quality_control_dropkick.json": [
		"./src/schema/react-json-schema/Tools/quality_control/quality_control_dropkick.json",
		"src_schema_react-json-schema_Tools_quality_control_quality_control_dropkick_json"
	],
	"./quality_control/quality_control_scanpy.json": [
		"./src/schema/react-json-schema/Tools/quality_control/quality_control_scanpy.json",
		"src_schema_react-json-schema_Tools_quality_control_quality_control_scanpy_json"
	],
	"./quality_control/quality_control_seurat.json": [
		"./src/schema/react-json-schema/Tools/quality_control/quality_control_seurat.json",
		"src_schema_react-json-schema_Tools_quality_control_quality_control_seurat_json"
	],
	"./visualization/visualization_t-sne.json": [
		"./src/schema/react-json-schema/Tools/visualization/visualization_t-sne.json",
		"src_schema_react-json-schema_Tools_visualization_visualization_t-sne_json"
	],
	"./visualization/visualization_umap.json": [
		"./src/schema/react-json-schema/Tools/visualization/visualization_umap.json",
		"src_schema_react-json-schema_Tools_visualization_visualization_umap_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/schema/react-json-schema/Tools lazy recursive ^\\.\\/.*\\/.*\\.json$ referencedExports: default";
module.exports = webpackAsyncContext;